import { Vue, Component } from 'vue-property-decorator';

@Component
export default class ShowPopUpControlsMobile extends Vue {
    isMobile = window.innerWidth <= 750;

    handleResize() {
        this.isMobile = window.innerWidth <= 750;
    }

    changeShowPopUpMode(selectedRadioButton, popUpType) {
        this.$emit('updateShowPopUp', {
            selectedRadioButton: selectedRadioButton,
            popUpType: popUpType,
            showPopUp: true,
            instance: this.instance,
        });
    }

    hidePopUp() {
        this.$emit('updateShowPopUp', {
            showPopUp: false,
        });
    }

    changeShowPopUpSwitch(isOn, popUpType) {
        this.$emit('updateShowPopUp', {
            popUpType: popUpType,
            showPopUp: true,
            isOn: isOn,
            instance: this.instance,
        });
    }
    changeShowPopUpBattery(batteryInformation, popUpType) {
        this.$emit('updateShowPopUp', {
            popUpType: popUpType,
            showPopUp: true,
            minSoc: batteryInformation.minSoc,
            essSoc: batteryInformation.essSoc,
            showActiveSocLimit: batteryInformation.showActiveSocLimit,
            socLimit: batteryInformation.socLimit,
            instance: this.instance,
        });
    }

    changeShowPopUpCurrentLimit(acInputIdx, currentInformation, popUpType) {
        this.$emit('updateShowPopUp', {
            popUpType: popUpType,
            showPopUp: true,
            acInputIdx: acInputIdx,
            acLimitAdjustable: currentInformation.acLimitAdjustable,
            isWaitingForResponse: currentInformation.isWaitingForResponse,
            suggestedAmperages: currentInformation.suggestedAmperages,
            acLimits: currentInformation.acLimits,
            error: currentInformation.error,
            //Used for ChargingStation.vue
            isManual: currentInformation.isManual,
            current: currentInformation.current,
            instance: this.instance,
        });
    }

    get confirmedChoiceViaPopUp() {
        if (this.popUpData.confirmedChoice) {
            return this.popUpData.confirmedChoice;
        } else {
            return '';
        }
    }

    confirmESSChoice() {
        const targetEss = this.$refs.ess.find(
            ess => ess.instance === this.confirmedChoiceViaPopUp.confirmedInstance,
        );
        if (targetEss) {
            switch (this.popUpType) {
                case 'ESS':
                    targetEss.changeSystemMode(
                        targetEss.convertOptionNameToValue(
                            this.confirmedChoiceViaPopUp.confirmedRadioButton,
                        ),
                    );
                    this.handleShowNotificationMobile(
                        this.confirmedChoiceViaPopUp.confirmedRadioButton,
                    );
                    break;
                case 'ESS-BATTERY':
                    if (this.confirmedChoiceViaPopUp.confirmedBatterySlider) {
                        targetEss.changeMinimumSoc(
                            this.confirmedChoiceViaPopUp.confirmedBatterySlider[0],
                        );
                        this.handleShowNotificationMobile(targetEss.minSocChange.newState);
                    }
                    break;
                case 'SWITCH-DYNAMIC-ESS':
                    targetEss.changeEssMode(!this.confirmedChoiceViaPopUp.confirmedIsOn);
                    this.handleShowNotificationMobile(Boolean(targetEss.essModeChange.newState));
                    break;
            }
        }
    }

    get confirmedChoice() {
        return this.confirmedChoiceViaPopUp;
    }

    get popUpType() {
        return this.confirmedChoice.confirmedPopUpType;
    }

    get isEssPopUpMobile() {
        return (
            this.popUpType === 'ESS' ||
            this.popUpType === 'ESS-BATTERY' ||
            this.popUpType === 'SWITCH-DYNAMIC-ESS'
        );
    }

    get isInverterPopUpMobile() {
        return this.popUpType === 'INVERTER' || this.popUpType === 'INVERTER-GRID-LIMIT';
    }

    get isSwitchesPopUpMobile() {
        return this.popUpType === 'SWITCH-RELAYS';
    }

    confirmInverterChoice() {
        // Find the specific inverter instance
        const targetInverter = this.$refs.inverter.find(
            inv => inv.instance === this.confirmedChoiceViaPopUp.confirmedInstance,
        );
        if (targetInverter) {
            switch (this.popUpType) {
                case 'INVERTER':
                    targetInverter.changeMode(
                        targetInverter.convertOptionNameToValue(
                            this.confirmedChoiceViaPopUp.confirmedRadioButton,
                        ),
                    );
                    this.handleShowNotificationMobile(
                        targetInverter.getRadioValue(targetInverter.inverterModeChange.newState),
                    );
                    break;
                case 'INVERTER-GRID-LIMIT':
                    targetInverter.changeLimit({
                        inputNr: this.confirmedChoiceViaPopUp.confirmedInputCurrentLimit[1],
                        value: this.confirmedChoiceViaPopUp.confirmedInputCurrentLimit[0],
                    });
                    this.handleShowNotificationMobile(targetInverter.acLimitChange.newState);
            }
        }
    }

    confirmSwitchChoice() {
        const targetSwitch = this.$refs.switches.find(
            switches => switches.instance === this.confirmedChoiceViaPopUp.confirmedInstance,
        );
        if (targetSwitch) {
            targetSwitch.setRelay({
                relayNr: this.confirmedChoiceViaPopUp.confirmedRelayIdx,
                value: !this.confirmedChoiceViaPopUp.confirmedIsOn,
            });
            const changedValue =
                Number(this.confirmedChoiceViaPopUp.confirmedRelayIdx) === 0
                    ? targetSwitch.relay0Change.newState
                    : targetSwitch.relay1Change.newState;
            this.handleShowNotificationMobile(changedValue);
        }
    }

    get isGeneratorPopUpMobile() {
        return (
            this.popUpType === 'SWITCH-AUTO-START' ||
            this.popUpType === 'SWITCH-TIMED-RUN' ||
            this.popUpType === 'SWITCH-MANUAL-START' ||
            this.popUpType === 'SWITCH-MANUAL-STOP' ||
            this.popUpType === 'SWITCH-RESET-SERVICE'
        );
    }

    confirmGeneratorChoice() {
        const targetGenerator = this.$refs.generator.find(
            generator => generator.instance === this.confirmedChoiceViaPopUp.confirmedInstance,
        );
        if (targetGenerator) {
            switch (this.popUpType) {
                case 'SWITCH-AUTO-START':
                    targetGenerator.setAutoStart(!this.confirmedChoiceViaPopUp.confirmedIsOn);
                    this.handleShowNotificationMobile(
                        Boolean(targetGenerator.autoStartEnabledChange.newState),
                    );
                    break;
                case 'SWITCH-TIMED-RUN':
                    targetGenerator.timedRun = !this.confirmedChoiceViaPopUp.confirmedIsOn;
                    this.handleShowNotificationMobile(Boolean(targetGenerator.timedRun));
                    break;
                case 'SWITCH-MANUAL-START':
                    targetGenerator.manualStart != 1 && targetGenerator.startGeneratorTimer();
                    this.handleShowNotificationMobile(Boolean(!targetGenerator.manualTimer));
                    break;
                case 'SWITCH-MANUAL-STOP':
                    targetGenerator.manualStart === 1 && targetGenerator.stopGeneratorTimer();
                    this.handleShowNotificationMobile(Boolean(!targetGenerator.manualTimer));
                    break;
                case 'SWITCH-RESET-SERVICE':
                    targetGenerator.resetService();
                    this.handleShowNotificationMobile(null);
                    break;
            }
        }
    }

    get isChargingStationPopUpMobile() {
        return (
            this.popUpType === 'CHARGING-STATION' ||
            this.popUpType === 'CHARGING-STATION-CURRENT' ||
            this.popUpType === 'SWITCH-CHARGING-STATION-CHARGE'
        );
    }

    confirmChargingStationChoice() {
        const targetChargingStation = this.$refs.chargingStation.find(
            chargingStation =>
                chargingStation.instance === this.confirmedChoiceViaPopUp.confirmedInstance,
        );
        if (targetChargingStation) {
            switch (this.popUpType) {
                case 'CHARGING-STATION':
                    targetChargingStation.setMode(
                        targetChargingStation.getRadioValue(
                            this.confirmedChoiceViaPopUp.confirmedRadioButton,
                        ),
                    );
                    this.handleShowNotificationMobile(
                        this.confirmedChoiceViaPopUp.confirmedRadioButton,
                    );
                    break;
                case 'CHARGING-STATION-CURRENT':
                    targetChargingStation.changeLimit(
                        this.confirmedChoiceViaPopUp.confirmedInputCurrentLimit,
                    );
                    this.handleShowNotificationMobile(targetChargingStation.currentChange.newState);
                    break;
                case 'SWITCH-CHARGING-STATION-CHARGE':
                    targetChargingStation.toggleStartStop(
                        !this.confirmedChoiceViaPopUp.confirmedIsOn,
                    );
                    this.handleShowNotificationMobile(
                        Boolean(targetChargingStation.startStopChange.newState),
                    );
                    break;
            }
        }
    }

    confirmInverterRsChoice() {
        const targetInverterRs = this.$refs.inverterRs.find(
            inverterRs => inverterRs.instance === this.confirmedChoiceViaPopUp.confirmedInstance,
        );
        if (targetInverterRs) {
            targetInverterRs.changeMode(
                targetInverterRs.getRadioValueFromName(
                    this.confirmedChoiceViaPopUp.confirmedRadioButton,
                ),
            );
            this.handleShowNotificationMobile(
                targetInverterRs.getRadioValue(targetInverterRs.inverterModeChange.newState),
            );
        }
    }

    get isMultiRsPopUpMobile() {
        return this.popUpType === 'MULTI-RS';
    }

    get isInverterRsPopUpMobile() {
        return this.popUpType === 'INVERTER-RS';
    }

    confirmMultiRsChoice() {
        const targetMultiRs = this.$refs.multiRs.find(
            multiRs => multiRs.instance === this.confirmedChoiceViaPopUp.confirmedInstance,
        );
        if (targetMultiRs) {
            targetMultiRs.changeMode(
                targetMultiRs.getRadioValueFromName(
                    this.confirmedChoiceViaPopUp.confirmedRadioButton,
                ),
            );
            this.handleShowNotificationMobile(
                targetMultiRs.getRadioValue(targetMultiRs.multiModeChange.newState),
            );
        }
    }

    confirmAcSystemChoice() {
        const targetAcSystem = this.$refs.acSystem.find(
            acSystem => acSystem.instance === this.confirmedChoiceViaPopUp.confirmedInstance,
        );
        if (targetAcSystem) {
            switch (this.popUpType) {
                case 'AC-SYSTEM':
                    targetAcSystem.changeMode(
                        targetAcSystem.convertOptionNameToValue(
                            this.confirmedChoiceViaPopUp.confirmedRadioButton,
                        ),
                    );
                    targetAcSystem.handleShowNotificationMobile(
                        targetAcSystem.getRadioValueFromName(
                            targetAcSystem.inverterModeChange.newState,
                        ),
                    );
                    break;
                case 'AC-SYSTEM-GRID-LIMIT':
                    targetAcSystem.changeLimit({
                        inputNr: this.confirmedChoiceViaPopUp.confirmedInputCurrentLimit[1],
                        value: this.confirmedChoiceViaPopUp.confirmedInputCurrentLimit[0],
                    });
                    this.handleShowNotificationMobile(targetAcSystem.acLimitChange.newState);
                    break;
            }
        }
    }

    get isAcSystemEssPopUpMobile() {
        return (
            this.popUpType === 'AC-ESS-BATTERY' ||
            this.popUpType === 'SWITCH-DYNAMIC-AC-ESS' ||
            this.popUpType === 'AC-ESS'
        );
    }

    get isAcSystemPopUpMobile() {
        return this.popUpType === 'AC-SYSTEM-GRID-LIMIT' || this.popUpType === 'AC-SYSTEM';
    }
    confirmAcSystemEssChoice() {
        const targetAcSystemEss = this.$refs.acSystemEss.find(
            acSystemEss => acSystemEss.instance === this.confirmedChoiceViaPopUp.confirmedInstance,
        );
        if (targetAcSystemEss) {
            switch (this.popUpType) {
                case 'AC-ESS':
                    targetAcSystemEss.changeAcSystemEssMode(
                        targetAcSystemEss.convertOptionNameToValue(
                            this.confirmedChoiceViaPopUp.confirmedRadioButton,
                        ),
                    );
                    this.handleShowNotificationMobile(
                        targetAcSystemEss.getRadioNameFromValue(
                            targetAcSystemEss.acSystemEssModeChange.newState,
                        ),
                    );
                    break;
                case 'AC-ESS-BATTERY':
                    if (this.confirmedChoiceViaPopUp.confirmedBatterySlider) {
                        targetAcSystemEss.changeMinimumSoc(
                            this.confirmedChoiceViaPopUp.confirmedBatterySlider[0],
                        );
                        this.handleShowNotificationMobile(targetAcSystemEss.minSocChange.newState);
                    }
                    break;
                case 'SWITCH-DYNAMIC-AC-ESS':
                    targetAcSystemEss.changeDessMode(!this.confirmedChoiceViaPopUp.confirmedIsOn);
                    this.handleShowNotificationMobile(targetAcSystemEss.dessModeChange.newState);
                    break;
            }
        }
    }
}
